import { HFlow, Text, TextProps } from 'bold-ui'
import { ReactNode } from 'react'

interface RequiredLabelProps extends TextProps {
  label: ReactNode
  inline?: boolean
}

export function RequiredLabel(props: RequiredLabelProps) {
  const { label, inline = false, ...rest } = props

  return inline ? (
    <HFlow hSpacing={0.25} alignItems='center'>
      <Text {...rest}>
        {label}
        <Text color='danger' title='Campo obrigatório'>
          {' '}
          *
        </Text>
      </Text>
    </HFlow>
  ) : (
    <HFlow hSpacing={0.25} alignItems='center'>
      <Text {...rest}>{label}</Text>
      <Text color='danger' title='Campo obrigatório'>
        {' '}
        *
      </Text>
    </HFlow>
  )
}
